import { useQuery } from '@tanstack/react-query'
import SalesReportsAPI from '../api/SalesReportsAPI'
import {
  IngredientsSalesTableByLanguagePayloadModel,
  QUERY
} from '../api/SalesReportsAPI.model'

function useIngredientsSalesTable(
  params: IngredientsSalesTableByLanguagePayloadModel
) {
  const enabled = Boolean(params.startDate && params.endDate)
  return useQuery({
    queryKey: [
      QUERY.INGREDIENTS_SALES_TABLE_BY_LANGUAGE,
      params.startDate,
      params.endDate,
      params.limit,
      params.typeFilter
    ],
    queryFn: () => SalesReportsAPI.getIngredientsSalesTableByLanguage(params),
    enabled,
    refetchOnWindowFocus: false
  })
}

export default useIngredientsSalesTable
